// Camada de serviço para Parcelamentos MEI, delegando para a API centralizada
import apiFactory from './api'

// Uso: const service = parcelamentosService('das')
export default function parcelamentosService(route = '') {
  const api = apiFactory(route)

  return {
    getPaginado(page, pageSize, filtros) {
      return api.getPaginado(page, pageSize, filtros)
    },
    getParcelas(parcelamentoId) {
      return api.getParcelas(parcelamentoId)
    },
    getParcelasRecentes(parcelamentoId) {
      return api.getParcelasRecentes(parcelamentoId)
    },
    getGuiaParcela(parcelamentoId, parcelaId) {
      return api.getGuiaParcela(parcelamentoId, parcelaId)
    },
    baixaEmLote(filtros, nomeArquivo) {
      return api.baixaEmLote(filtros, nomeArquivo)
    },
    enviarEmail(nomeEmpresa, emailEmpresa, emailCc, id, parcelaId, mensagemAdicional, definirEmailPadrao) {
      return api.enviarEmail(nomeEmpresa, emailEmpresa, emailCc, id, parcelaId, mensagemAdicional, definirEmailPadrao)
    },
    getObservacoes(id) {
      return api.getObservacoes(id)
    },
    removerObservacao(id) {
      return api.removerObservacao(id)
    },
    salvarObservacao(observacao) {
      return api.salvarObservacao(observacao)
    },
  }
}
